export const PERIODS = 'periods';
export const PERIOD_TYPE = 'periodType';
export const DATA_PERIOD = 'trackerPeriod';
export const PAY_TO = 'payTo';
export const COMPARE_PERIOD = 'trackerPeriodToCompare';

export const LAST_7_DAYS = 'Last7Days';

export const TODAY = 1;
export const PERIODS_LAST_DAY = 2;
